<script lang="ts" module>
  import Icon from '@/ui/base/icon/Icon.svelte';
</script>

<footer class="flex gap-3 p-4">
  <Icon icon="TCLLogo" size={14.5} class="flex-none" />
  <div class="grid flex-1 content-end justify-end">
    <p>Alle Rechte tcl.digital.</p>
  </div>
  <div class="grid flex-none content-end justify-end">
    <a
      class="font-sans text-sm font-normal text-c-link"
      href="https://tcl.digital/impressum-datenschutz/"
      target="_blank">Datenschutzerklärung</a
    >
  </div>
</footer>
